module.exports = __webpack_public_path__ + "images/emoji/de.bea7b090b514628c25d5.png";